import { call, put } from "redux-saga/effects";

import { AuthService } from "../../services/AuthService";
import { ISignInResponse } from "../../models";
import { LocalStorageService } from "../../services/LocalStorageService";
import { signInSuccess } from "../../store/actions";

export function* login(action: any) {
  try {
    const loginResponse: ISignInResponse = yield call(
      AuthService.signIn,
      action.payload
    );

    if (loginResponse.status) {
      LocalStorageService.setUser(loginResponse);
      yield put(signInSuccess(loginResponse));
    }

    
  } catch (err) {
    
  }
}
